export const DESCRIPTION_TOOLTIP = `Инструкция по распределению заявок

При автоматическом распределении заявок вы можете
использовать три опции и один коэффициент, которые можно комбинировать для достижения нужного результата.
Опции распределения:
1. "Равномерная загрузка работников с учетом времени"
Как работает: Это "умное" распределение.
Система пытается распределить заявки между работниками так,
чтобы у каждого было примерно одинаковое количество рабочего времени.
Учитывается время на дорогу и продолжительность выполнения заявки.
Система проверяет, есть ли у работника свободное "окно" в расписании для новой заявки.
Когда использовать: Используйте эту опцию, когда хотите максимально эффективно загрузить работников,
избегая переработок и простоев. Это основной и самый сбалансированный режим.
2. "Равномерное распределение всех заявок (по кол-ву)"
Как работает: Этот режим гарантирует, что все новые заявки будут распределены.
Распределение происходит по количеству заявок на каждого работника.
Например, если у вас 10 заявок и 2 работника, каждый получит по 5 заявок, независимо от того, сколько времени займет их выполнение.
Когда использовать: Используйте, когда вам нужно срочно распределить все поступившие заявки,
и не так важно, что у одного работника общая продолжительность работ может быть больше, чем у другого.
3. "Равномерное распределение всех заявок (по длительности)"
Как работает: Этот режим также гарантирует распределение всех новых заявок.
Но в отличие от предыдущего,
он старается сделать так, чтобы общая продолжительность всех заявок у каждого работника была примерно одинаковой.
Когда использовать: Используйте, когда важно, чтобы все работники были загружены на примерно одинаковое общее время,
и при этом нужно распределить абсолютно все заявки.

Коэффициент:
"Коэффициент увеличения/уменьшения времени работ" (percentageValue)
Как работает: Этот коэффициент умножает расчетную длительность каждой задачи.
Например, если задача обычно занимает 60 минут, а коэффициент установлен на 1.1 (110%),
то система будет считать, что задача займет 66 минут. Если коэффициент 0.9 (90%), то задача займет 54 минуты.
Влияние на распределение:
"Равномерная загрузка работников с учетом времени": Увеличение коэффициента приведет к тому,
что система будет выделять больше времени на каждую задачу,
что может уменьшить количество задач, которые могут быть назначены работнику в определенный временной слот.
Уменьшение коэффициента, наоборот, позволит назначить больше задач.
"Равномерное распределение всех заявок (по длительности)":
Коэффициент напрямую влияет на расчет общей длительности задач для каждого работника,
стремясь к равномерному распределению скорректированной длительности.
"Равномерное распределение всех заявок (по кол-ву)":
Этот коэффициент не оказывает прямого влияния, так как распределение происходит исключительно по количеству задач, а не по их длительности.
Когда использовать: Используйте этот коэффициент для тонкой настройки загрузки работников.
Например, если вы знаете, что расчетное время задач часто недооценивается или переоценивается,
вы можете скорректировать его этим коэффициентом.
Как выбирать и комбинировать опции:

Только "Равномерная загрузка работников с учетом времени": Стандартное, наиболее сбалансированное распределение.
Рекомендуется в большинстве случаев. Коэффициент будет влиять на то, сколько задач поместится в расписание работника.
Только "Равномерное распределение всех заявок (по кол-ву)":
Быстрое распределение всех заявок поровну (по количеству).
Коэффициент не влияет на логику распределения, но может быть использован для других целей,
если это предусмотрено в других частях системы.•Только "Равномерное распределение всех заявок (по длительности)":
Быстрое распределение всех заявок поровну (по времени). Коэффициент напрямую влияет на расчет длительности,
обеспечивая равномерное распределение скорректированного времени.
"Равномерная загрузка работников с учетом времени" и "Равномерное распределение всех заявок (по кол-ву)":
В этом случае приоритет будет у "Равномерное распределение всех заявок (по кол-ву)".
Система распределит все заявки по их количеству. Коэффициент не будет влиять на логику распределения.
"Равномерная загрузка работников с учетом времени" и "Равномерное распределение всех заявок (по длительности)":
Приоритет будет у "Равномерное распределение всех заявок (по длительности)".
Система распределит все заявки, стараясь выровнять общую продолжительность работ, скорректированную коэффициентом.
Все три вместе: Приоритет будет у "Равномерное распределение всех заявок (по кол-ву)" и
"Равномерное распределение всех заявок (по длительности)".
Если "Равномерное распределение всех заявок (по длительности)" активно, то распределение будет по времени (с учетом коэффициента),
иначе по количеству.Итог:
Для умного и гибкого распределения используйте
"Равномерная загрузка работников с учетом времени".
Если нужно гарантированно распределить все заявки, используйте
"Равномерное распределение всех заявок (по кол-ву)" (для равенства по количеству) или
"Равномерное распределение всех заявок (по длительности)" (для равенства по времени).
Последний является более предпочтительным для равномерной загрузки.
"Коэффициент увеличения/уменьшения времени работ" используйте для корректировки расчетной длительности задач,
что повлияет на распределение при использовании опций, учитывающих время или длительность.
`;
